import React from "react";
import styled from "styled-components";
import { FONTS, COLORS, BREAKPOINTS } from "../utils/styleConstants";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--background-color);
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const Title = styled.h1`
  color: ${COLORS.SECONDARY};
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-family: ${FONTS.PRIMARY};
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: ${COLORS.PRIMARY};
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: ${FONTS.PRIMARY};
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  color: ${COLORS.TEXT};
  font-family: ${FONTS.SECONDARY};
`;

const TermsPage = () => {
  return (
    <PageContainer>
      <Header />
      <MainContent>
        <Title>Términos de Uso</Title>
        
        <Section>
          <SectionTitle>1. Aceptación de los Términos</SectionTitle>
          <Paragraph>
            Al acceder o utilizar Ofertas Vinculantes, aceptas estar sujeto a estos Términos de Uso. Si no estás de acuerdo con alguna parte de estos términos, no podrás acceder al servicio.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>2. Uso del Servicio</SectionTitle>
          <Paragraph>
            Nuestros servicios están diseñados para ayudarte a encontrar y gestionar ofertas vinculantes. Te comprometes a utilizar nuestros servicios únicamente para fines legales y de acuerdo con estos términos.
          </Paragraph>
          <Paragraph>
            No debes utilizar nuestros servicios de manera que pueda dañar, deshabilitar, sobrecargar o deteriorar nuestros servidores o redes, ni interferir con el uso y disfrute de nuestros servicios por parte de otros usuarios.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>3. Cuentas de Usuario</SectionTitle>
          <Paragraph>
            Al crear una cuenta con nosotros, debes proporcionar información precisa, completa y actualizada. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, y de restringir el acceso a tu computadora o dispositivo. Aceptas la responsabilidad por todas las actividades que ocurran bajo tu cuenta o contraseña.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>4. Propiedad Intelectual</SectionTitle>
          <Paragraph>
            El servicio y su contenido original, características y funcionalidad son propiedad de Ofertas Vinculantes y están protegidos por derechos de autor, marcas registradas, patentes, secretos comerciales y otras leyes de propiedad intelectual o derechos de propiedad.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>5. Limitación de Responsabilidad</SectionTitle>
          <Paragraph>
            En ningún caso Ofertas Vinculantes, sus directores, empleados, socios, agentes, proveedores o afiliados serán responsables por cualquier daño indirecto, incidental, especial, consecuente o punitivo, incluyendo sin limitación, pérdida de beneficios, datos, uso, buena voluntad, u otras pérdidas intangibles, resultantes de tu acceso o uso o incapacidad para acceder o usar el servicio.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>6. Modificaciones</SectionTitle>
          <Paragraph>
            Nos reservamos el derecho, a nuestra sola discreción, de modificar o reemplazar estos términos en cualquier momento. Es tu responsabilidad revisar estos términos periódicamente para verificar los cambios. Tu uso continuado de los servicios después de la publicación de cualquier modificación constituye la aceptación de esos cambios.
          </Paragraph>
        </Section>
        
        <Section>
          <SectionTitle>7. Contacto</SectionTitle>
          <Paragraph>
            Si tienes preguntas sobre estos Términos de Uso, por favor contáctanos en: founders@ofertasvinculantes.es
          </Paragraph>
        </Section>
      </MainContent>
      <Footer />
    </PageContainer>
  );
};

export default TermsPage; 